import React, { useState } from "react";
import { Square, SquareCheck, X } from "lucide-react";

export default function PlanScheduleSubstatusModal({
  options = [],
  selectedIds = [],
  isGlobal = false,
  onClose,
  onConfirm,
}) {
  const [allSelected, setAllSelected] = useState(isGlobal);
  const [selected, setSelected] = useState(
    () => new Set((selectedIds || []).map(Number))
  );

  function toggle(id) {
    setSelected((prev) => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  }

  function handleConfirm() {
    if (allSelected) {
      onConfirm({ is_global: true, ids: [] });
    } else {
      onConfirm({ is_global: false, ids: Array.from(selected) });
    }
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/70">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md max-h-[80vh] flex flex-col">
        <div className="flex flex-row items-center justify-between border-b px-4 py-3">
          <h2 className="text-md font-bold">Substatus</h2>
          <button
            type="button"
            onClick={onClose}
            className="bg-secondary rounded-md p-1 px-2 h-6 flex flex-row items-center justify-center text-xs gap-1"
          >
            <X size={16} /> Close
          </button>
        </div>
        <div className="flex flex-col gap-1 overflow-y-auto p-2">
          <button
            type="button"
            onClick={() => setAllSelected((prev) => !prev)}
            className="flex flex-row items-center gap-2 text-left text-sm font-bold rounded-md p-2 hover:bg-gray-100 border-b"
          >
            {allSelected ? <SquareCheck size={16} /> : <Square size={16} />}
            ALL Substatus
          </button>
          {options.length === 0 && (
            <span className="text-xs text-gray-400 p-2">
              No substatus available.
            </span>
          )}
          {options.map((option) => {
            const checked = !allSelected && selected.has(option.id);
            return (
              <button
                key={option.id}
                type="button"
                disabled={allSelected}
                onClick={() => toggle(option.id)}
                className={`flex flex-row items-center gap-2 text-left text-sm rounded-md p-2 ${
                  allSelected
                    ? "opacity-40 cursor-not-allowed"
                    : "hover:bg-gray-100"
                }`}
              >
                {checked ? <SquareCheck size={16} /> : <Square size={16} />}
                {option.name}
              </button>
            );
          })}
        </div>
        <div className="flex flex-row items-center justify-end gap-2 border-t px-4 py-3">
          <button
            type="button"
            onClick={onClose}
            className="border rounded-md p-2 text-xs"
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            className="bg-mila_orange text-white rounded-md p-2 px-4 text-xs font-bold"
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
}
